export const environment = {
  production: false,
  keepSession: false,
  apiPropostaUrl: 'https://portalproposta-hom.cloud.itau.com.br/imobiliario-portalproposta-aws/v1',
  apiPropostaNewUrl:
    'https://tracking-imobiliario-v1-credimob.api-sp.hom.aws.cloud.ihf/tracking-imobiliario/v1',
  X_ORIGIN_CF_APIGW:
    'g9Vi59e0hileG4wOSqFvKd0bv04xz+rz5ivi58PIu29DvgU1GNKT6P4ozywZvTcdLoCmjLceMKjZIzwsEy1GOQ==',
  X_ITAU_API_KEY: 'bf854952-849c-45d5-ab5b-0cc666cb61af',
  reCaptchaKey: '6LeD_A4sAAAAAFb3YPmTf6wqxFmCAHN2Nl6dfOHT',
  assetsRoot: 'https://acompanhar-proposta-hom.cloud.itau.com.br/assets',

  entryPoints: {
    'local': {
      charonid: 'seb7jclu',
      entryPoint: `https://apicd.hom.cloud.itau.com.br/charon/seb7jclu`,
      cryptography: false
    }
  },
  sdkUrl: 'https://sdk-analytics-web-hom.cloud.itau.com.br/index.js',
  isProd: false,
  configDataDog: {
    gtm: 'GTM-KSB5C24G',
    observability: {
      name: 'IC5-app-credimobcanais-trackingconsultafe',
      version: '1.0.0',
      env: 'hom',
      sigla: 'IC5',

      applicationURL: 'https://acompanhar-proposta-hom.cloud.itau.com.br/',
      datadog: {
        logs: {
          clientToken: 'IC5-app-credimobcanais-trackingconsultafe-browser'
        },
        rum: {
          applicationId: '52d8ef7b-5050-45b2-a9a8-e854da16e737',
          clientToken: 'IC5-app-credimobcanais-trackingconsultafe-browser'
        }
      }
    }
  }
};
